import { FormControl, FormControlProps, FormLabel, HStack, useRadioGroup, UseRadioGroupProps } from '@chakra-ui/react';
import React, { useEffect } from 'react';
import { ColorPickerOption } from './ColorPickerOption';

interface ColorPickerProps extends UseRadioGroupProps {
  options: Option[];
  rootProps?: FormControlProps;
  hideLabel?: boolean;
  label?: string;
}

interface Option {
  color: string;
  label: string;
}

export const ColorPicker = (props: ColorPickerProps) => {
  const { options, rootProps, hideLabel, label, ...rest } = props;
  const { getRadioProps, getRootProps, value, setValue } = useRadioGroup(rest);
  const selectedOption = options.find((option) => option.label === value);

  // Handle reset or external value changes
  useEffect(() => {
    // eslint-disable-next-line react/destructuring-assignment
    if (props.value !== value) {
      // eslint-disable-next-line react/destructuring-assignment
      setValue(props.value || '');
    }
    // eslint-disable-next-line react/destructuring-assignment
  }, [props?.value]);

  return (
    <FormControl {...rootProps}>
      {!hideLabel && (
        <FormLabel fontSize='sm' fontWeight='medium'>
          {label ?? `Colour: ${selectedOption?.label ?? '-'}`}
        </FormLabel>
      )}
      {/* eslint-disable-next-line @typescript-eslint/ban-ts-comment */}
      {/* @ts-ignore */}
      <HStack {...getRootProps()}>
        {options.map((option) => (
          <ColorPickerOption key={option.color} color={option.color} {...getRadioProps({ value: option.label })} />
        ))}
      </HStack>
    </FormControl>
  );
};
